export default __webpack_public_path__ + "static/media/Power_icon.f5ca67e7.svg";